let Emitter = require("./Emitter");

let baseUrl = "";

let globalHeaders = {};

let authFn = function (url) {
  return Promise.resolve(null);
};

let request = function (method, _url, data, headers) {
  let serializable = typeof data === "object" && !(data instanceof FormData);
  let payload = serializable ? JSON.stringify(data) : data;

  let url = _url.match(/^(\.|http)/) ? _url : baseUrl + _url;

  return authFn(url).then(function (user) {
    return new Promise(function (resolve, reject) {
      let xhr = new XMLHttpRequest();
      xhr.open(method, url);
      xhr.timeout = 0;

      if (serializable) {
        xhr.setRequestHeader("Content-Type", "application/json");
      }

      for (let h in globalHeaders) {
        xhr.setRequestHeader(h, globalHeaders[h]);
      }

      for (let h in headers) {
        xhr.setRequestHeader(h, headers[h]);
      }

      if (user) {
        xhr.setRequestHeader("Authorization", "Basic " + btoa(user.id + ":" + user.token));
      }

      xhr.onerror = function () {
        reject(new AjaxError("Cannot load " + url, xhr));
        Ajax.emit("fatal", xhr.status, xhr.getAllResponseHeaders());
        Ajax.emit("after", xhr.status, xhr.getAllResponseHeaders());
      };

      xhr.ontimeout = function () {
        reject(new AjaxError("Timed out while loading " + url, xhr));
        Ajax.emit("after", xhr.status, xhr.getAllResponseHeaders());
        Ajax.emit("fatal", xhr.status, xhr.getAllResponseHeaders());
      };

      xhr.onload = function () {
        resolve(xhr.responseText);
        Ajax.emit("after", xhr.status, xhr.getAllResponseHeaders());
      };

      xhr.onreadystatechange = function () {
        let stat;
        let msg;

        if (xhr.readyState === 4) {
          stat = xhr.status;

          if (!stat || ((stat < 200 || stat >= 300) && stat !== 304)) {
            try {
              msg = JSON.parse(xhr.responseText).message;
            }
            catch (e) {
              msg = "Cannot load " + url + " (" + stat + ")";
            }

            reject(new AjaxError(msg, xhr));

            if (stat >= 400) {
              Ajax.emit("fatal", xhr.status, xhr.getAllResponseHeaders());
            }
          }
        }
      };

      Ajax.emit("before");
      xhr.send(payload);
    });
  });
};

let AjaxError = function (message, xhr) {
  this.name = "AjaxError";
  this.message = message;
  this.status = xhr.status;
  this.response = xhr.response;
  this.stack = (new Error()).stack;
};

AjaxError.prototype = Object.create(Error.prototype);
AjaxError.prototype.constructor = AjaxError;

let Ajax = new Emitter({
  AjaxError: AjaxError,

  get(url, headers = {}) {
    return request("GET", url, undefined, { ...headers, "If-Modified-Since": "0" });
  },

  post(url, data, headers = {}) {
    return request("POST", url, data, headers);
  },

  put(url, data, headers = {}) {
    return request("PUT", url, data, headers);
  },

  del(url, headers = {}) {
    return request("DELETE", url, {}, headers);
  },

  base(_baseUrl) {
    baseUrl = _baseUrl;
  },

  auth(_authFn) {
    authFn = _authFn;
  },

  headers(_globalHeaders) {
    globalHeaders = _globalHeaders;
  },

  parse(response) {
    try {
      return JSON.parse(response);
    }
    catch (e) {
      Ajax.emit("fatal", 0);
    }
  },

  serialize(data) {
    let q = [];

    for (let i in data) {
      q.push(i + "=" + encodeURIComponent(data[i]));
    }

    return q.join("&");
  },

  mock(status, response, latency) {
    setTimeout(function () {
      Ajax.emit("before");
    }, 50);

    return new Promise(function (resolve, reject) {
      let fn;
      let txt = JSON.stringify(response);

      if (status === 200) {
        fn = resolve.bind(null, txt);
      }
      else {
        fn = reject.bind(null, new AjaxError("Oops!", { status: status, response: txt }));
      }

      setTimeout(function () {
        fn();
        Ajax.emit("after", status, {});

        if (status >= 400) {
          Ajax.emit("fatal", status);
        }
      }, latency || 500);
    });
  }
});

module.exports = Ajax;
